import { assoc } from 'ramda';
import { combineReducers } from 'redux';
import { keyBy, map } from 'lodash/fp';

import {
  FETCH_PO_LOCATIONS,
  FETCH_PO_LOCATIONS_ERROR,
  FETCH_PO_LOCATIONS_SUCCESS,
  PO_LOCATION_UPDATED,
} from './constants';

const byId = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_PO_LOCATIONS_SUCCESS:
      return keyBy('ownerId', payload);
    case PO_LOCATION_UPDATED:
      return assoc(payload.ownerId, payload, state);
    default:
      return state;
  }
};

const list = (state = [], { type, payload }) => {
  switch (type) {
    case FETCH_PO_LOCATIONS_SUCCESS:
      return map('ownerId', payload);
    default:
      return state;
  }
};

const loading = (state = false, { type }) => {
  switch (type) {
    case FETCH_PO_LOCATIONS:
      return true;
    case FETCH_PO_LOCATIONS_SUCCESS:
    case FETCH_PO_LOCATIONS_ERROR:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  list,
  loading,
});
